// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )         ( 開關按鈕 )
// ------------------------------------

import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Account from '../../actions/Account'
import ApiGo from '../../actions/ApiGo'
// import { LOGIN_STATE } from '../../App'
import { LOGIN_STATE } from '../../LoginStatus'
import { CLEAR_LAYOUT } from '../../stores/reducer_LayoutPage'
import { CLEAR_RESIDENTS_ARRAY } from '../../stores/reducer_residentsArray'
import { CLEAR_USER_ARRAY } from '../../stores/reducer_usersArray'

const DEVICES = new Account().get_user_devices()

const LogoutBtnMobile =(props)=>{

    const { t } = useTranslation()

    const dispatch = useDispatch()
    // storage clear
    function clearStorage(){
        dispatch(CLEAR_USER_ARRAY())
        dispatch(CLEAR_RESIDENTS_ARRAY())
        dispatch(CLEAR_LAYOUT())
    }
    function logout() {
        let a = new Account
        a.logout()
        .then(()=>{clearStorage() })
        a = null
    }


    return(
        <div onClick={props.hide} className="pos-f z-1 wid-full hig-full top-0 left-0">
            <div className="pos-a r-0 transLogout " onClick={e => e.stopPropagation()}>
                <div className="fx-d-r skew parallel-before">
                    <div className="parallel first fx-ccc" onClick={logout} >
                        <div className="skew-revese fx-ccc pad-3 b pad-5 t">
                            {t("AUDIT_TRAIL.EVENTS.LOGOUT")}
                        </div>
                    </div>
                    <div className="parallel second fx-ccc " onClick={props.hide}>
                        <div className="skew-revese fx-ccc pad-3 b pad-5 t bd-up">
                            {t("GLOBAL.CANCEL")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );	

}
export default LogoutBtnMobile;